import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, CreditCardIcon, DownloadIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const trustSignals = [{
  icon: LockIcon,
  label: 'Sichere 256-Bit Verschlüsselung'
}, {
  icon: CreditCardIcon,
  label: 'Stripe Zahlungsgateway'
}, {
  icon: DownloadIcon,
  label: 'Sofort-Download nach Zahlung'
}, {
  icon: BadgeCheckIcon,
  label: 'Geld-zurück-Garantie'
}];
export function Hero() {
  return <section className="relative overflow-hidden border-b border-line bg-canvas" data-id="element-34" data-mp="x9usbrnwe8ay">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 py-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:gap-16 lg:py-20" style={{
      paddingTop: "0px",
      paddingBottom: "0px",
      gap: "5px",
      backgroundColor: "#F9FBF9",
      backgroundImage: "none"
    }} data-id="element-35" data-mp="sb1axo5hpx5i">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-36" data-mp="3czfms3kkof85">
          <p className="font-mono text-sm font-semibold tracking-wide text-emerald" style={{
          fontSize: "16px",
          textAlign: "center"
        }} data-id="element-37" data-mp="3j9u0ky5t7mla">🌱 KODA DIGITAL</p>

          <h1 className="mt-5 font-serif text-4xl font-semibold leading-[1.12] tracking-tight text-forest sm:text-5xl lg:text-[3.3rem]" style={{
          fontSize: "24px",
          textAlign: "center",
          paddingTop: "0px",
          paddingBottom: "0px",
          marginTop: "5px",
          marginBottom: "5px",
          fontWeight: "800",
          fontFamily: "Inter, sans-serif"
        }} data-id="element-38" data-mp="39authk0ozz0e">
            Deine Pflanzen sterben nicht wegen dir.{' '}
            <span className="text-emerald" style={{
            fontSize: "20px"
          }} data-id="element-39" data-mp="2ql6e4z9bqr65">SIE STERBEN, WEIL DU NICHT WISSEN KANNST, WAS IHNEN FEHLT.</span>
          </h1>

          <h2 className="mt-6 max-w-xl text-lg leading-relaxed text-prose sm:text-xl" style={{
          fontWeight: "800",
          color: "#115C2C",
          fontSize: "16px",
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-40" data-mp="2hinbog9gagkf"><img src="https://cdn.magicpatterns.com/uploads/6yapYx9vYUgizBke44VaXe/ChatGPT_Image_17_sept_2026,_03_33_17_p.m..png" alt="Vorher-Nachher-Vergleich: links frustrierte Urban Farmerin mit vertrockneten Pflanzen, rechts erfolgreiche Ernte mit dem Urban Farming System" className="block h-auto w-full rounded-2xl" style={{
            filter: 'drop-shadow(0 26px 38px rgba(27, 48, 34, 0.22))',
            paddingTop: "0px",
            paddingBottom: "0px"
          }} data-id="element-41" data-mp="s1rsao8pe6ua" />
            🌱 Das 11-teilige Schritt-für-Schritt System für fehlerfreie Hochleistungs-Ernten auf kleinstem Raum – ohne Zeit oder Geld zu verschwenden.  AUCH WENN DU NOCH NIE GEMÜSE AUF DEM BALKON ANGEBAUT HAST: DIESES SYSTEM FÜHRT DICH SCHRITT FÜR SCHRITT VON NULL BIS ZU DEINEM ERSTEN FUNKTIONIERENDEN URBAN-FARMING-SETUP  🌱
          </h2>

          <div className="mt-9" style={{
          marginTop: "0px",
          marginBottom: "0px"
        }} data-id="element-42" data-mp="x3h1dycd8afq">
            <CtaButton label="JETZT ZUM SYSTEM-ZUGANG" href="#angebot" className="w-full sm:w-auto" data-id="element-43" data-mp="3lqm3q21erbwi" />
            
          </div>

          

          <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 pb-3" data-id="element-44" data-mp="1xacfj35u5jt8">
            {trustSignals.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm text-prose" style={{
            paddingTop: "0px",
            paddingBottom: "0px",
            marginTop: "0px",
            marginBottom: "0px",
            gap: "3px"
          }} data-id="element-45" data-mp="269zihte7qxoe">
                <Icon className="h-4 w-4 text-emerald" aria-hidden="true" data-id="element-46" data-mp="2g0lqp2jlolx2" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        {/* HERO-BILD: Dieses Bild kann direkt hier ersetzt werden (Bild anklicken und austauschen
            oder die URL im src unten ersetzen). */}
        <div className="w-full" data-id="element-47" data-mp="2tyipm5lj14ew">
          
        </div>
      </div>
    </section>;
}